import { showUpdateToast } from "./updateToast";

/**
 * Registers src/service-worker.js (production builds only; `npm start` builds no
 * service worker) and tells people when a newer ANNA has been deployed. An
 * installed app can stay open in the background for days, so it also checks for
 * a new version whenever it comes back to the screen.
 */

const CHECK_EVERY_MS = 30 * 60 * 1000;

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  const start = async () => {
    // A page that was already controlled is running the previous version once a new one takes over.
    // On the very first visit the worker takes over too, but nothing on the page is out of date.
    let hadController = Boolean(navigator.serviceWorker.controller);
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (hadController) showUpdateToast();
      hadController = true;
    });

    try {
      const registration = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`);
      let lastCheck = Date.now();
      const checkForUpdate = () => {
        if (document.visibilityState !== "visible" || Date.now() - lastCheck < CHECK_EVERY_MS) return;
        lastCheck = Date.now();
        registration.update().catch(() => {});
      };
      document.addEventListener("visibilitychange", checkForUpdate);
      setInterval(checkForUpdate, CHECK_EVERY_MS);
    } catch (error) {
      console.warn("ANNA service worker was not registered:", error);
    }
  };

  if (document.readyState === "complete") start();
  else window.addEventListener("load", start, { once: true });
}
